import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGTM, useQuery, useUserOrders, useBannerVisibility } from 'hooks';
import { useFeatureFlag, FLAGS } from 'lib/featureFlags';
import { Loader } from '@teespring/ts-components';
import get from 'lodash/get';
import { delightedScript } from 'lib/delighted';
import useScript from 'hooks/useScripts';
// import useOnboardingChecklist from 'hooks/useOnboardingChecklist';
import axios from 'axios';
import WhatsNew from './WhatsNew';
import VerificationToast from './VerificationToast';
import EmailVerifyBar from './EmailVerifyBar';
import { API_HOST } from '../../constants';
// import OnboardingChecklist from './OnboardingChecklist';

import './Overview.scss';
import './Overview.css';

import IntegrationShelf from './IntegrationShelf';
import PromoBanner from './PromoBanner';
// import AnalyticsOverview from './AnalyticsOverview';

const Overview = () => {
  const emailVerificationEnabled = useFeatureFlag(FLAGS.EMAIL_VERIFICATION);
  // const [displayChecklist, setDisplayChecklist] = useState(true);

  // const { dismissed, dismissChecklist, checklist, loading } =
  //   useOnboardingChecklist();
  // useEffect(() => {
  //   setDisplayChecklist(!dismissed);
  // }, [dismissed]);
  const user = useSelector((state) => get(state, 'header.user'));
  const { userId } = useSelector((state) => state.user);
  // const handleDismissClick = () => {
  //   dismissChecklist();
  // };

  const isFetchingUserSubscriptions = useSelector(
    (state) => state.subscriptions.isFetchingUserSubscriptions
  );

  const { query } = useQuery();
  const { pushAccountToDataLayer } = useGTM();

  const { verified, email } = user;

  // const recentlySignedUpUser = useSelector((state) =>
  //   get(state, 'user.recentlySignedUp', false)
  // );

  const needVerifyEmailBar =
    !query.get('verified') && emailVerificationEnabled && !verified;

  useEffect(() => {
    pushAccountToDataLayer();
  }, [pushAccountToDataLayer]);

  // delighted survey
  const { orders } = useUserOrders(user.id);

  const [listings, setListings] = useState([]);
  useEffect(() => {
    const fetchListings = async () => {
      const perPage = 10;
      const { data } = await axios.get(`${API_HOST}/api/v1/user/listings`, {
        withCredentials: true,
        params: {
          userId,
          per: perPage,
          page: 1,
          sortBy: 'createdDate',
          orderBy: 'DESC'
        }
      });
      return data.listings;
    };
    fetchListings().then(setListings);
  }, [userId]);

  useScript(
    delightedScript(user, listings?.length > 0, orders && orders?.length > 0)
  );

  // Banner active from 9:00 AM PST, December 12th, 2024 to 9:00 AM PST, December 23rd, 2024
  const isLastMinuteHolidaySaleVisible = useBannerVisibility(
    '2024-12-12T17:00:00Z',
    '2024-12-23T17:00:00Z'
  );

  // Banner active from November 1st, 2024, 9:00 AM PST (4:00 PM UTC) to end of December 31, 2024 (midnight PST)
  // const isHolidayBannerVisible = useBannerVisibility(
  //   '2024-11-01T16:00:00Z',
  //   '2025-01-01T08:00:00Z'
  // );

  const upperBanners = [
    {
      id: 'amaze_commerce_live_banner',
      desktopSrc: require('../../assets/amaze_commerce_live_desktop.png'),
      mobileSrc: require('../../assets/amaze_commerce_live_mobile.png'),
      alt: 'Amaze Commerce is now live',
      link: 'https://app.amazecommerce.com/signup?utm_source=platform&utm_medium=platform&utm_campaign=ac+platform+page&utm_content=ac+platform+page',
      isVisible: true
    },
    // {
    //   id: 'redemption_banner_adobe_express',
    //   desktopSrc: require('../../assets/dt_overview_spring_gtm.png'),
    //   mobileSrc: require('../../assets/banner_adobe_344x294.5.png'),
    //   alt: 'Adobe express redemption banner',
    //   link: 'https://www.amaze.co/adobe-redemption',
    //   isVisible: isBannerVisible
    // },
    {
      id: 'promo_banner_last_minute_holiday_sale',
      desktopSrc: require('../../assets/last-minute-holiday-sale_desktop.png'),
      mobileSrc: require('../../assets/last-minute-holiday-sale_mobile.png'),
      alt: 'last minute holiday sale',
      link: '',
      isVisible: isLastMinuteHolidaySaleVisible
    },
    {
      id: 'promo_banner_amaze_resource_hub',
      desktopSrc: require('../../assets/one_percent_better_dt.png'),
      mobileSrc: require('../../assets/one_percent_better_mob.png'),
      alt: 'amaze resource hub',
      link: 'https://www.amaze.co/winter-25-resource-hub',
      isVisible: true
    },
    {
      id: 'promo_banner_samples_increase_sales',
      desktopSrc: require('../../assets/ThreeTimesSamples_Desktop.png'),
      mobileSrc: require('../../assets/ThreeTimesSamples_Mobile.png'),
      alt: 'samples increase sales',
      link: 'https://dashboard.teespring.com/samples',
      isVisible: true
    }
  ];

  const lowerBanners = [
    // {
    //   id: 'promo_banner_college_ambassadors',
    //   desktopSrc: require('../../assets/dt_college_ambassadors.png'),
    //   mobileSrc: require('../../assets/mob_college_ambassadors.png'),
    //   alt: 'college ambassadors',
    //   link: 'https://share.hsforms.com/1HoP2rgLuR_STYT9qOt1qVQe19c5'
    // },
    {
      id: 'promo_banner_discord',
      desktopSrc: require('../../assets/discord-dashboard_desktop.png'),
      mobileSrc: require('../../assets/discord-dashboard_mobile.png'),
      alt: 'discord hub',
      link: 'https://discord.gg/Rb2QkpSu'
    }
  ];

  // Filter banners based on visibility
  const visibleUpperBanners = upperBanners.filter((banner) => banner.isVisible);

  return isFetchingUserSubscriptions ? (
    <Loader />
  ) : (
    <div className='overview_cont'>
      <div className='overview'>
        <VerificationToast className='overview__verification__toast' />
        <section className='overview__content'>
          {needVerifyEmailBar && <EmailVerifyBar email={email} />}
          <div className='firstBanner'>
            <PromoBanner banners={visibleUpperBanners} />
          </div>
          <div className='secondBanner'>
            {/* {!recentlySignedUpUser && <AnalyticsOverview />} */}
          </div>
        </section>
      </div>
      <div className='thirdBanner'>
        <IntegrationShelf />
        <WhatsNew className='fourthBanner' />
      </div>
      <div className='fifthBanner'>
        <div className='overview'>
          <PromoBanner banners={lowerBanners} />
        </div>
      </div>
    </div>
  );
};

export default Overview;
